export const ANIMATION_SPEED = 500;
export const DESKTOP_SLICES_PER_VIEW = 2;
export const MOBILE_SLICES_PER_VIEW = 3;
